import type { PrizeDrop } from "@/campaigns/modules/prizedrop/types";

import { FinishedCampaignCard } from "./finished-campaign-card";
import { Typography } from "@/components/ui/typography";
import { useTranslation } from "react-i18next";

/** "Ended 28 Jun" — null if the campaign end date doesn't parse. */
const formatEndDate = (end: unknown): string | null => {
  if (typeof end !== "string") return null;
  const d = new Date(end);
  if (Number.isNaN(d.getTime())) return null;
  return new Intl.DateTimeFormat(undefined, {
    day: "numeric",
    month: "short",
  }).format(d);
};

/**
 * Finished prize drop in the results grid. There is no per-player result data
 * for prize drops (no win stream yet), so unlike the tournament card this shows
 * the ended date rather than "you won".
 */
export const FinishedPrizeDropCard = ({
  prizeDrop,
}: {
  prizeDrop: PrizeDrop;
}) => {
  const { t } = useTranslation();
  const ended = formatEndDate(prizeDrop.campaign.end);

  return (
    <FinishedCampaignCard campaign={prizeDrop.campaign}>
      <Typography tag="h5" className="text-muted-foreground">
        {ended
          ? t("campaign.endedOn", "Ended {{date}}", { date: ended })
          : t("campaign.ended", "Ended")}
      </Typography>
    </FinishedCampaignCard>
  );
};
